module.exports = __webpack_public_path__ + "img/circular-logging.44d92be1.jpg";